import { schemes, zSchema } from "@zeal/common";

export const downloadLaborPosterTemplateRequestSchema = zSchema.array(
  schemes.uuid()
);

export type TDownloadLaborPosterTemplateRequestSchema = zSchema.infer<
  typeof downloadLaborPosterTemplateRequestSchema
>;
